module.exports = __webpack_public_path__ + "static/media/ex-feuture-icon1.a9269c27.svg";